module.exports = "/_next/static/images/you_omurice-73283bab72f175dc6c7c47683d845afd.jpg";